export default "__VITE_ASSET__53bf11ea__"